import MarketingContentPage from "@/components/marketing/MarketingContentPage"

export default function Community() {
  return <MarketingContentPage pageKey="community" seoKey="community" />
}
